export const isOfTypeWithValue = <T, U>(param: T | U, value: string): param is T => {
  return Boolean((param as T)[value])
}
